import React from 'react';
import PropTypes from 'prop-types';

import BulkSafeDeletePage from '../components/App/BulkSafeDeleteInstance/BulkSafeDeletePage';

const BulkSafeDeleteRoute = ({ basePath }) => {
  return (
    <BulkSafeDeletePage
      basePath={basePath}
    />
  );
};

BulkSafeDeleteRoute.propTypes = {
  basePath: PropTypes.string.isRequired,
};

export default BulkSafeDeleteRoute;
